export default {
  path: '/ev_charging_stations',
  component: () => import('@/layouts/PublicLayout'),
  redirect: '/ev_charging_stations/:id/road_book',
  children: [
    {
      path: ':id/road_book',
      component: () => import('@/views/ev_charging_stations/RoadBook.vue'),
      meta: {
        title: '路书指引'
      }
    }
  ]
}
